import { render } from "./DispatchOrderCard.vue?vue&type=template&id=188e099f&scoped=true&ts=true"
import script from "./DispatchOrderCard.vue?vue&type=script&lang=ts"
export * from "./DispatchOrderCard.vue?vue&type=script&lang=ts"

import "./DispatchOrderCard.vue?vue&type=style&index=0&id=188e099f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188e099f"]])

export default __exports__